document.addEventListener("DOMContentLoaded", function () {
    if (document.getElementById("product-lifecycle")) {
        import(/* webpackChunkName: "legacy-products" */ "/Features/Products/Common/js/legacy-products.js").then(async (module) => {
            new module.default();
        });
    }
});